import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideo

export default createSelector(
	[ interactiveVideoData ],
	interactiveVideoData => {
		const mediaId = interactiveVideoData.media.asset ? interactiveVideoData.media.asset.uid : ''
		return {
			mediaId,
			breakpoints: interactiveVideoData.media.breakpoints,
		}
	}
)
